import React from 'react';

const BillingToggle = ({ isYearly, setIsYearly }) => {
  return (
    <div className="flex justify-center mb-6">
      <div className="relative flex w-full max-w-xs items-center rounded-full bg-gray-100 p-1">
        {/* Background Slider */}
        <div
          className={`absolute top-1 bottom-1 left-1 h-[calc(100%-8px)] w-[calc(50%-4px)] transform rounded-full bg-black transition-transform duration-300 ease-out
            ${isYearly ? 'translate-x-full' : 'translate-x-0'}
          `}
        />

        {/* Monthly Button */}
        <button
          type="button" // Good practice for buttons not submitting forms
          className={`relative z-10 flex-1 rounded-full px-3 py-2 text-center text-sm font-medium transition-colors duration-300 focus:outline-none
            ${!isYearly ? 'text-white' : 'text-gray-600 hover:text-gray-800'}
          `}
          onClick={() => setIsYearly(false)}
        >
          Monthly
        </button>

        {/* Yearly Button */}
        <button
          type="button"
          className={`relative z-10 flex-1 rounded-full px-3 py-2 text-center text-sm font-medium transition-colors duration-300 focus:outline-none
            ${isYearly ? 'text-white' : 'text-gray-600 hover:text-gray-800'}
          `}
          onClick={() => setIsYearly(true)}
        >
          Yearly <span className="text-xs opacity-75">-25%</span>
        </button>
      </div>
    </div>
  );
};

export default BillingToggle;